
import React from 'react'

export function TeamCard(props) {
    const img = props.img
    const name = props.name
    const title = props.title
    const desc = props.desc
    return (
        <div className="flex flex-col xl:flex-row w-[420px] xl:h-[200px] items-center   justify-start space-y-[24px] xl:space-y-0 xl:space-x-[25px]">
            <img src={`/assets/img/${img}`} className="rounded-full max-w-[120px]" />

            <div className="flex flex-col  text-center xl:text-start leading-[18px] px-[75px] xl:px-0  ">
                <p className="font-bold">{name} </p>
                <p className="font-semibold text-[#808080] pb-[10px] text-[13px]">{title}</p>
                <hr className="py-[5px]  " />
                <span className="text-[12px] leading-[15px] text-center xl:text-justify ">
                    {desc}
                </span>
            </div>
        </div>
    )
}


export default function Team({ history }, props) {


    return (
        <div className='flex w-full items-start justify-center'>
            <div className="flex flex-col w-[full] xl:w-[1100px] items-center justify-start space-y-[32px] px-[24px] text-[14px]   pb-[100px]">


                <div className="flex flex-col xl:flex-row    items-start w-full justify-start   ">
                    <div className="hidden xl:flex justify-center w-[100px] xl:h-[300px] items-center">
                        <img src={'/assets/img/aboutus.png'} />
                    </div>




                    <div className="flex text-justify items-center px-[20px] xl:w-[calc(100%-400px)]  xl:h-[300px] text-[14px] xl:pr-[40px]">
                        23rd Studio is a KTH spin-off that specializes in software and platform design using artificial intelligence technologies and intuitive design. Over the past decade, the founders of 23rd Studio have gained valuable experience in assisting companies and research groups in realizing their machine learning projects. 23rd Studio, along with its advisory board, is dedicated to helping companies and organizations enhance their understanding of artificial intelligence and implementing these technologies within their services and products.
                    </div>
                    <div className="hidden  justify-center xl:block xl:w-[350px]  "  >
                        <img src={'/assets/img/robot/robots-01.png'} width="300px" />

                    </div>

                </div>

                <div className="flex w-full justify-center text-[25px] text-center  p-[20px] items-center  xl:hidden ">
                                   <div className="flex w-full justify-center text-[25px] text-center  px-[35px] py-[20px] items-center border-b xl:hidden border-[#dddddd]">

                    <img src={'/assets/img/ourteam-vertical.png'} className="w-[119px] h-[21px]" />
                    </div>
                </div>



                <div className="flex  w-full justify-center">
                    <div className="hidden xl:flex justify-center items-center w-[100px] ">
                        <img src={'/assets/img/ourteam.png'} className="w-[21px] h-[119px]" />
                    </div>
                    <div className="flex flex-col space-y-[1px] w-[400px] xl:w-[calc(100%-100px)]  ">

                        <div className="grid grid-cols-1 gap-[50px] xl:grid-cols-2  content-between ">



                            <TeamCard
                                img="team_mem_1.png"
                                name="Heydar Maboudi Afkham, PhD"
                                title="Founder, Lead Machine Learning Scientist"
                                desc="Heydar has more than 15 years of experience in developing machine learning solutions for both commercial and academic entities."
                            />
                            <TeamCard
                                img="team_mem_2.png"
                                name="Farimah Fatemi"
                                title="Lead UX/Interaction Designer"
                                desc="Farimah, with over a decade of experience in UX/Interaction design for AI projects, has a wealth of knowledge and expertise in this field."
                            />

                            <TeamCard
                                img="team_mem_3.png"
                                name="Zohreh Shangi"
                                title="Software Developer"
                                desc="Zohreh has more than 5 years of experience in developing software platforms enabling AI solutions and services."
                            />



                        </div>



                    </div>
                </div>



            </div>
        </div>

    )

}

